module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bW55N"))).then(() => parcelRequire('f4eak'));